import { Link } from 'react-router-dom';
import { UserProfileDropdown } from './UserProfileDropdown';
import { NotificationBell } from '../notifications/NotificationBell';
import { Container } from './Container';
import { Flex } from './Flex';
import { useNavigationStore } from '@/store/navigationStore';
import { useAuthStore } from '@/store/authStore';
import { SyncStatus } from '../sync/SyncStatus';
import { Logo } from '../ui/Logo';
import { NotificationPermissionBanner } from '../notifications/NotificationPermissionBanner';

export function Header() {
  const { currentPageTitle } = useNavigationStore();
  const { isAuthenticated } = useAuthStore();

  return (
    <header className="sticky top-0 z-40 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <NotificationPermissionBanner />
      <Container size="full">
        <Flex justify="between" align="center" className="h-14 sm:h-16 px-2 sm:px-4">
          {/* Left section - Logo and Page Title */}
          <Flex align="center" gap="md" className="min-w-0 flex-shrink">
            <Link
              to="/"
              className="header-logo-link group flex-shrink-0"
              aria-label="GodMode home"
            >
              <div className="transition-transform group-hover:scale-110">
                <Logo size="md" className="sm:hidden" />
                <Logo size="lg" className="hidden sm:block" />
              </div>
            </Link>
            <h1 className="text-base sm:text-xl font-bold text-blue-600 truncate">
              {currentPageTitle}
            </h1>
          </Flex>

          {/* Right section - Actions and Profile */}
          <Flex align="center" gap="sm" className="flex-shrink-0">
            {/* Sync Status & Notifications - only show when authenticated */}
            {isAuthenticated && (
              <>
                <SyncStatus />
                <NotificationBell />
              </>
            )}

            {/* Menu Dropdown - always visible */}
            <UserProfileDropdown />
          </Flex>
        </Flex>
      </Container>
    </header>
  );
}